/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';
import { mapOrderRowToGTMProduct } from '@/data/events/data/gtm/productAttributes';
import { GTMPurchasePayload } from '@/data/types/GTM';
import { OrderItem } from '@/data/types/Order';
import { dAdd, dFix } from '@/data/utils/floatingPoint';
import { isValidClickProductView } from '@/data/utils/isValidClickProductView';

const clickSourceOf = (attributes: OrderItem['orderItemExtendAttribute']) => {
	if (!Array.isArray(attributes)) {
		return undefined;
	}
	const value = attributes.find(
		(attribute) => attribute?.attributeName === 'recommended'
	)?.attributeValue;
	return isValidClickProductView(value) ? (value as CLICK_PRODUCT_VIEW_SOURCE) : undefined;
};

export const getGTMPurchaseEventData = async (payload: GTMPurchasePayload) => {
	const { cart, contextData, storeName, orgName, orgId, orderItemListRows = [] } = payload;
	const {
		grandTotal: cartValue = 0,
		grandTotalCurrency: cartCurrency = '',
		totalShippingCharge: cartShipping,
		totalSalesTax,
		totalShippingTax,
		orderId,
		totalAdjustment: cartAdjustments,
	} = cart;
	const hcl_account = orgId ? orgName : null;
	const cartTax = `${dAdd(dFix(totalSalesTax ?? 0), dFix(totalShippingTax ?? 0))}`;
	const marketplaceStore = storeName;

	const products = orderItemListRows.map((row) => {
		const orderItemId = row.orderItemListRow.itemDetails.orderItemId;
		return {
			...mapOrderRowToGTMProduct(row),
			category: contextData?.[orderItemId]?.category?.identifier ?? '',
			coupon: '',
			item_list_id: clickSourceOf(row.orderItemListRow.orderItem?.orderItemExtendAttribute),
		};
	});

	return {
		orderId,
		cartValue: Number(cartValue),
		cartCurrency,
		cartTax,
		cartShipping,
		cartAdjustments,
		products,
		hcl_account,
		marketplaceStore,
		payMethods: cart.paymentInstruction,
	};
};
